import { IconButtonProps } from '@chakra-ui/react';
import React from 'react';

import { CmIconButton } from '@/components/uiParts';
import { AddIcon } from '@/components/uiParts';

export const CmAddIconButton: React.FC<IconButtonProps> = ({
  id,
  isDisabled,
  onClick,
}) => {
  return (
    // @ts-ignore TS2590
    <CmIconButton
      aria-label="追加"
      colorScheme="darkBlue"
      icon={<AddIcon />}
      {...{ id, isDisabled, onClick }}
    />
  );
};
